import { render } from "./Company_Dialog.vue?vue&type=template&id=538d6245&scoped=true&ts=true"
import script from "./Company_Dialog.vue?vue&type=script&lang=ts"
export * from "./Company_Dialog.vue?vue&type=script&lang=ts"

import "./Company_Dialog.vue?vue&type=style&index=0&id=538d6245&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538d6245"]])

export default __exports__